var map = {
	"./p1.jpg": 9518,
	"./p10.jpg": 9220,
	"./p11.jpg": 7265,
	"./p12.jpg": 7654,
	"./p2.jpg": 5465,
	"./p3.jpg": 3852,
	"./p4.jpg": 167,
	"./p5.jpg": 9002,
	"./p6.jpg": 6853,
	"./p7.jpg": 9240,
	"./p8.jpg": 2003,
	"./p9.jpg": 6742
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7896;